<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="looksInactive()" (click)="enabledToggled.emit()"></button>
  </span>
  <span class="filter-body equipment-filter-from-preset">
    <span class="favourite-currency-fixed-label">{{ label() }}</span>
    <span class="sep"></span>
    <app-autocomplete
      [allowAll]="true"
      allLabel="None"
      [options]="baseTypeOptions()"
      [disabled]="isRowInactive()"
      [showOptions]="true"
      [selectedValues]="baseTypes()"
      (selectedValuesChange)="baseTypesChange.emit($event)"></app-autocomplete>
    <span class="sep"></span>
    <app-select style="width: 125px; min-width: 125px;" [disabled]="looksInactive()" [ngModel]="mode()" (selectedValueChange)="modeChange.emit($event)">
      <app-option [value]="FavouriteCurrencyMode.Multiplier" [text]="'Multiplier'"></app-option>
      <app-option [value]="FavouriteCurrencyMode.PromoteTier" [text]="'Promote Tier'"></app-option>
      <app-option [value]="FavouriteCurrencyMode.ForceVisible" [text]="'Force Visible'"></app-option>
    </app-select>
    @if (mode() !== FavouriteCurrencyMode.ForceVisible) {
      <span class="sep"></span>
      <input type="number" placeholder="value" pattern="[0-9.,]*" inputmode="decimal" step="any" class="form-control minmax" style="min-width: 55px;"
        [disabled]="looksInactive()"
        [ngModel]="value()" (ngModelChange)="valueChange.emit($event)">
    }
    <span class="sep"></span>
    <div class="remove-btn-placeholder"></div>
  </span>
</div>
